import { SectionRow, SectionBullet, SectionTitleText, SectionDivider } from './styles';

export function SectionHead({ title, bullet, compact }) {
  return (
    <SectionRow $compact={compact}>
      <SectionBullet $color={bullet} />
      <SectionTitleText>{title}</SectionTitleText>
      <SectionDivider />
    </SectionRow>
  );
}
